const initialState = {
    categories: [],
    selectedCat: null, 
    content: [],
    detailsIndex: null, // vaghti rooye dokmeye edameye matlab click mishe, index content ro dar in moteghayer zakhire mikonim
    dataType: 'all', // all | text | media
};
const blog = (state = initialState, action) => {
    switch (action.type) {
        case 'CHANGE_DATA_PAGE_BLOG':
           return {...state, [action.name]: action.value};
        default:
            return state;
    }
};

export default blog;
